import { Layout } from "../components/Layout";

/** Legal page (route "/impressum") — kept directly on the landing site so it
 *  stays reachable independent of the app's own gate (§5 TMG Impressumspflicht). */
export function Impressum(): JSX.Element {
  return (
    <Layout>
      <div className="container-welope py-14 sm:py-20 lg:py-24">
        <div className="mx-auto max-w-2xl">
          <nav aria-label="Brotkrumen" className="mb-6">
            <ol className="flex items-center gap-2 font-body text-label-sm text-on-surface-variant">
              <li>
                <a href="/" className="transition-colors hover:text-primary">
                  Start
                </a>
              </li>
              <li aria-hidden>›</li>
              <li className="text-primary">Impressum</li>
            </ol>
          </nav>

          <h1 className="font-headline text-[34px] font-extrabold leading-[1.1] tracking-[-0.02em] text-primary sm:text-[46px]">
            Impressum
          </h1>

          <div className="mt-10 space-y-10">
            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                solutioIT
                <br />
                Inhaber: Jamie Hennemann
                <br />
                Hauptstraße 5
                <br />
                56479 Liebenscheid
                <br />
                Deutschland
              </p>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Gemäß § 19 Abs. 1 UStG wird keine Umsatzsteuer erhoben (Kleinunternehmerregelung).
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                Kontakt
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Telefon: 02667 8323219
                <br />
                E-Mail: info@solutioit.de
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Jamie Hennemann
                <br />
                Hauptstraße 5
                <br />
                56479 Liebenscheid
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                Streitschlichtung
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                bereit, abrufbar unter{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary hover:opacity-80"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht verpflichtet
                und nicht bereit, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                Haftung für Inhalte
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
                als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
                fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
                Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
                konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                Rechtsverletzungen werden wir diese Inhalte umgehend entfernen. Dies betrifft
                insbesondere von Nutzer:innen hochgeladene Beiträge, Fotos, Videos und Kommentare
                (nutzergenerierte Inhalte).
              </p>
            </section>

            <section>
              <h2 className="font-headline text-headline-lg leading-tight text-primary">
                Haftung für Links
              </h2>
              <p className="mt-4 font-body text-body-md leading-[1.65] text-on-surface-variant">
                Unser Angebot enthält gegebenenfalls Links zu externen Websites Dritter, auf deren
                Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte
                auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
                jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
